import { Crown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export default function BlkGptPage() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <Helmet>
        <title>BLKGPT - AI for Black Communities | BlackBook</title>
        <meta name="description" content="BLKGPT - Our Lineage. Our Knowledge. Our Power. An AI assistant rooted in FBA history and culture." />
        
        <meta property="og:title" content="BLKGPT - AI for Black Communities | BlackBook" />
        <meta property="og:description" content="Our Lineage. Our Knowledge. Our Power. AI rooted in FBA history." />
        <meta property="og:image" content="https://www.blackbook.family/logo.jpeg" />
        <meta property="og:url" content="https://www.blackbook.family/blkgpt" />
        <meta property="og:type" content="website" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BLKGPT - AI for Black Communities" />
        <meta name="twitter:description" content="Our Lineage. Our Knowledge. Our Power." />
        <meta name="twitter:image" content="https://www.blackbook.family/logo.jpeg" />
      </Helmet>
      <div className="text-center">
        <Crown className="text-yellow-500 mx-auto mb-6" size={80} />
        <h1 className="text-6xl font-bold text-white mb-4">BLKGPT</h1>
        <p className="text-2xl text-white font-medium">
          Our Lineage. Our Knowledge. Our Power.
        </p>
      </div>
    </div>
  );
}
